import React from 'react'

import { NavLink } from 'react-router-dom'

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="columns has-text-grey">
        <div className="column has-text-centered">
          Duty Labs © 2018
          <NavLink style={{marginLeft: '10px',}} className="link" to="mailto:contact@dutylabs.ro" target="_top">Support</NavLink>
          <NavLink style={{marginLeft: '10px',}} className="link" to="/terms">Terms &amp; Privacy Policy</NavLink>
          <NavLink style={{marginLeft: '10px',}} className="link" to="/features" target="_top">Features</NavLink>
          <NavLink style={{marginLeft: '10px',}} className="link" to="/faq" target="_top">FAQ</NavLink>
          <NavLink style={{marginLeft: '10px',}} className="link" to="https://blog.dutylabs.ro" target="_blank">Blog</NavLink>
        </div>
      </div>
    </div>
    <div className="container" style={{marginTop: '25px',}}>
      <div className="content has-text-centered">
        <p>
          <strong>Made</strong> with <i className="fa fa-heart"/> at <a href="https://dutylabs.ro">dutylabs</a>
        </p>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js